// src/pages/Admin/TableauDeBordAdherents/components/AdminDashboardHero.jsx

import React from "react";
import {
  FaChartPie,
  FaClipboardList,
  FaMobileAlt,
  FaUsers,
} from "react-icons/fa";

export default function AdminDashboardHero() {
  return (
    <section className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="relative overflow-hidden bg-gradient-to-br from-[#013E8E] via-indigo-700 to-[#4CA82F] px-5 py-6 text-white sm:px-7">
        <div className="absolute -right-16 -top-16 h-44 w-44 rounded-full bg-white/10 blur-3xl" />
        <div className="absolute -bottom-20 -left-16 h-48 w-48 rounded-full bg-emerald-300/20 blur-3xl" />

        <div className="relative">
          <div className="inline-flex items-center gap-2 rounded-full bg-white/15 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.18em] ring-1 ring-white/20">
            <FaMobileAlt />
            Mobile First
          </div>

          <h1 className="mt-4 text-2xl font-bold leading-tight sm:text-3xl">
            Tableau de bord adhérents
          </h1>

          <p className="mt-3 max-w-3xl text-sm leading-6 text-white/90">
            Une vue administrateur pensée pour smartphone : inscriptions,
            statuts, visites, cours, communes, statistiques et indicateurs clés
            du club.
          </p>

          <div className="mt-5 grid grid-cols-1 gap-2 sm:grid-cols-3">
            <div className="rounded-2xl bg-white/15 px-4 py-3 ring-1 ring-white/20">
              <div className="flex items-center gap-2 text-sm font-bold">
                <FaUsers />
                Adhérents
              </div>
              <p className="mt-1 text-xs text-white/80">
                Suivi des comptes et inscriptions.
              </p>
            </div>

            <div className="rounded-2xl bg-white/15 px-4 py-3 ring-1 ring-white/20">
              <div className="flex items-center gap-2 text-sm font-bold">
                <FaChartPie />
                Statistiques
              </div>
              <p className="mt-1 text-xs text-white/80">
                Répartition par statut, cours et commune.
              </p>
            </div>

            <div className="rounded-2xl bg-white/15 px-4 py-3 ring-1 ring-white/20">
              <div className="flex items-center gap-2 text-sm font-bold">
                <FaClipboardList />
                Subventions
              </div>
              <p className="mt-1 text-xs text-white/80">
                Tableaux prêts à copier.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}